import type { TSearchHighlight, TSearchMatch } from '../types/TSearch';

export const buildSearchHighlightMap = (matches: TSearchMatch[]): Map<string, TSearchHighlight[]> => {
  const highlightMap = new Map<string, TSearchHighlight[]>();

  matches.forEach((match, matchIndex) => {
    match.spans.forEach((span) => {
      const highlights = highlightMap.get(span.key) ?? [];

      highlights.push({
        startChar: span.startChar,
        endChar: span.endChar,
        matchIndex,
      });

      highlightMap.set(span.key, highlights);
    });
  });

  return highlightMap;
};
